import React, { useEffect, useState } from "react";
import { Button, Grid, Typography } from "@mui/material";
import { useForm, useWatch } from "react-hook-form";
// import InputTextFieldGrid from "./InputTextFieldGrid";
import InputSelectFieldGrid from "./InputSelectFieldGrid";
import CheckboxFieldGrid from "./CheckboxFieldGrid";
import InputDateRange from "./InputDateRange";
import InputTextFieldGrid from "./InputTextFieldGrid";
import InputMonthGrid from "./InputMonthGrid";
import CustomButton from "components/CustomButton";
import InputHourRange from "./InputHourRange";

const FilterBar = ({
  absolute = false,
  filters,
  handlerFilter,
  defaultValues,
  allValue = '',
  page,
  limit,
  showButton,
  showTitle = true,
  validateButton
}) => {
  const { control, reset, setValue } = useForm({ defaultValues });
  const fields = useWatch({ control, defaultValue: defaultValues });
  const [clean, setClean] = useState(0)

  useEffect(() => {
    handlerFilter(fields, reset)
    // eslint-disable-next-line
  }, [page, limit])

  useEffect(() => {
    if (showButton) return
    handlerFilter(fields, reset)
    // eslint-disable-next-line
  }, [fields])

  useEffect(() => {
    handlerFilter(fields, reset)
    // eslint-disable-next-line
  }, [clean])
  document.FILTER_BAR_SUBMIT = () => handlerFilter(fields, reset)
  return (
    <Grid container mt={2} sx={{ position: absolute ? 'absolute' : 'relative', }}>
      <Grid
        item
        container
        xs={12}
        justifyContent="center"
        alignContent="center"
      >
        <Grid item container alignItems={"center"} gap={2}>
          {(showTitle || showButton) && <Grid item gap={2} height={'100%'} alignItems={"center"} display={"flex"} flexDirection={"column"} justifyContent={"center"} >
            {
              showTitle && <Typography variant="h6" fontWeight="bold">
                Filtros
              </Typography>
            }
            {
              showButton &&
              <CustomButton
                name={'Buscar'}
                click={() => handlerFilter({ ...fields, page, limit }, reset)}
                disabled={validateButton ? validateButton(fields) : false}
              />
            }
            {
              showButton && <CustomButton
                name={'Limpiar'}
                click={() => {
                  reset()
                  setClean(clean + 1)
                }}
              />
            }
          </Grid>}
          <Grid flex={1} item container flexDirection={"row"} spacing={2} alignItems={"center"}>
            {filters.map(({ name, label, data, type, disabled, all, onSelect = () => { }, multiple, render, loading, format }) => (
              type === "select" ? (
                <InputSelectFieldGrid
                  key={name}
                  xs={3}
                  control={control}
                  name={name}
                  label={label}
                  data={!!all ? [{ id: allValue, name: all }, ...data] : data}
                  disabled={disabled}
                  displayEmpty={!!all}
                  onSelect={(value) => onSelect(value, setValue)}
                  multiple={multiple}
                  loading={loading}
                  // onOpen={() => setIsOpen(true)}
                  // onClose={() => setIsOpen(false)}
                  render={render}
                />
              ) : type === "date" ? (
                <InputTextFieldGrid
                  key={name}
                  xs={3}
                  name={name}
                  inputType={'date'}
                  control={control}
                  label={label}
                />
              ) : type === "dates" ? (
                <InputDateRange
                  key={name}
                  xs={3}
                  name={name}
                  control={control}
                  label={label}
                  format={format}
                  defaultValue={defaultValues && defaultValues[name]}
                />
              ) : type === "hourRange" ? (
                <InputHourRange
                  key={name}
                  xs={3}
                  name={name}
                  control={control}
                  label={label}
                  defaultValue={defaultValues && defaultValues[name]}
                />
              ): type === "month" ? (
                <InputMonthGrid
                  key={name}
                  xs={3}
                  name={name}
                  control={control}
                  label={label}
                  defaultValue={defaultValues && defaultValues[name]}
                />
              ) : type === "checkbox" ? (
                <CheckboxFieldGrid
                  key={name}
                  xs={3}
                  name={name}
                  control={control}
                  label={label}
                />
              ) : type === "text" ? (
                <InputTextFieldGrid
                  key={name}
                  xs={3}
                  name={name}
                  control={control}
                  label={label}
                />
              ) : null
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Grid >
  );
};

export default FilterBar;
